// extracted by mini-css-extract-plugin
export default {"root":"GalleryHero_root__jpyIJ","background":"GalleryHero_background__LjM7d","overlay":"GalleryHero_overlay__BtT5O","kicker":"GalleryHero_kicker__inx-v"};